export default __webpack_public_path__ + "static/media/MarkPro-Light.b52b95d1.otf";